import React, { useEffect, useState } from "react";
import { getStockHistory } from "./inventoryApi";

export default function StockHistory() {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadHistory = async () => {
    try {
      const res = await getStockHistory();
      setHistory(res.data);
    } catch (err) {
      console.error("History load failed:", err);
      setHistory([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadHistory();
  }, []);

  return (
    <div className="card shadow mt-3">
      <div className="card-header bg-light">
        <h5 className="mb-0">Stock History</h5>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th>Date</th>
              <th>Item</th>
              <th>Type</th>
              <th>Qty</th>
              <th>Reason</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center py-3">
                  Loading...
                </td>
              </tr>
            ) : history.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-3 text-muted">
                  No history found
                </td>
              </tr>
            ) : (
              history.map((h) => (
                <tr key={h.id}>
                  <td>
                    {new Date(h.created_at).toLocaleDateString()}{" "}
                    <small className="text-muted">
                      {new Date(h.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </small>
                  </td>

                  <td>{h.inventory?.name || "-"}</td>

                  <td>
                    <span
                      className={`badge ${
                        h.type === "IN" ? "bg-success" : "bg-danger"
                      }`}
                    >
                      {h.type === "IN" ? "Inward" : "Outward"}
                    </span>
                  </td>

                  <td>
                    {h.type === "IN" ? "+" : "-"}
                    {h.quantity} <small>{h.unit}</small>
                  </td>

                  <td>{h.reason || "-"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
